import React from 'react';
import { useLocation } from 'react-router';
import cx from 'classnames';

import Modal from '~/components/modals/modal';
import { Field, Form } from '~/components/form';
import Button from '~/components/button';
import PasswordField from '~/components/inputs/password-field';
import { useFlashMessage } from '~/features/flash-messages/flash-message-actions';
import { useUpdatePassword } from '~/features/user/user-actions';
import { required, strongPassword, valid } from '~/utils/validation';

import styles from '~/components/modals/modal.module.scss';

const UpdatePasswordModal = ({ onClose, isOpen, creationMethod }) => {
  const { showFlashMessage } = useFlashMessage();
  const location = useLocation();
  const updatePassword = useUpdatePassword();

  const handleSubmit = async (formValues) => {
    try {
      await updatePassword(formValues.newPassword, creationMethod);

      showFlashMessage('Your password has been updated.', 'success', 10000);

      delete location?.state?.redirectFrom; // clean up state
      onClose();
    } catch (err) {
      showFlashMessage(
        'Oops, there was an issue updating your password. Please try again later.'
      );
    }
  };

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      className={styles.updatePasswordModal}
    >
      <h1 className={cx(styles.title, styles.updatePasswordModalTitle)}>
        Password
      </h1>
      <Form
        onSubmit={handleSubmit}
        validate={validate}
        resetOnSubmit
        className={styles.updatePasswordForm}
      >
        {({ isSubmitting }) => (
          <>
            <div className={styles.passwordBanner}>
              New password must include 8 characters with a mix of letter
              casing, numbers, and punctuation.
            </div>
            <Field
              label="New password"
              name="newPassword"
              component={PasswordField}
            />
            <p className={styles.updatePasswordDescText}>
              Create a password to check your order status and track your
              shipments.
            </p>

            <div className={styles.updatePasswordFormButton}>
              <Button type="submit" isLoading={isSubmitting} fullWidth>
                Save
              </Button>
            </div>
          </>
        )}
      </Form>
    </Modal>
  );
};

function validate(formValues) {
  return {
    newPassword: valid(required(), strongPassword())(formValues.newPassword),
  };
}

export default UpdatePasswordModal;
